module.exports = __webpack_public_path__ + "img/home_map_India_lightblue.fd4891ef.png";